import { setSpecificMessage, hexColor } from "valibot";
setSpecificMessage(
  hexColor,
  (issue) => `Couleur hexa invalide: reçu ${issue.received}`,
  "fr"
);